export { default } from './TechParamsItem';
